import type { ReactNode } from 'react';

interface PageHeaderProps {
  kicker: string;
  title: ReactNode;
  lead?: ReactNode;
  actions?: ReactNode;
}

/** Left-aligned page opener over ruled paper. */
export function PageHeader({ kicker, title, lead, actions }: PageHeaderProps) {
  return (
    <header className="ruled border-b border-line">
      <div className="mx-auto max-w-site px-4 py-14 sm:px-6 md:py-24">
        <p className="label mb-5">{kicker}</p>
        <h1 className="max-w-4xl text-hero-mobile font-semibold tracking-heading md:text-hero-desktop">{title}</h1>
        {lead && <div className="mt-6 max-w-2xl text-base leading-relaxed text-ink-2 sm:text-lg">{lead}</div>}
        {actions && <div className="mt-8 flex flex-col gap-3 sm:flex-row">{actions}</div>}
      </div>
    </header>
  );
}
